
        var result = require("!!../../../../node_modules/css-loader/index.js!./h1.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/components/micro-components/h1-component/h1.component.css
// module id = 22
// module chunks = 0 1